import Dexie,{ Table } from 'dexie';

export interface MocJson {
    id?: number;
    name :string;
    key: string;
    value: ArrayBuffer;
}

export class DbCache extends Dexie {
    mocJson! :Table<MocJson>
    constructor(){
        super('Live2D-JWF');
        this.version(1).stores({
            mocJson: '++id, [name+key]' // Primary key and indexed props
        });
    }
}

export function ClearDb(){
    db.delete();
}

export const db = new DbCache();